module.exports = __webpack_public_path__ + "img/2024517-num1.fd1b963.svg";